import CustomerAssets from '../pages/customer-assets/pages/CustomerAssets'
import CreateCustomerAsset from '../pages/customer-assets/pages/CreateCustomerAsset';
import { USER_ROLES } from '../utils/userRole';

const permissions = [USER_ROLES.ADMIN]


const CustomerAssetsRoutes = [
  {
    path: '/assets',
    component: CustomerAssets,
    exact: true,
    permissions,
  },
  {
    path: '/assets/create',
    component: CreateCustomerAsset,
    exact: true,
    permissions,
  },
  {
    path: '/assets/edit/:id',
    component: CreateCustomerAsset,
    exact: true,
    permissions,
  },
];

export default CustomerAssetsRoutes
